import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Box from "@material-ui/core/Box";
import * as Email from "email-validator";
import apiRequest from "../common/api-request";
import customLocalStorage from "../common/local-storage";
import ResetPassword from "./reset-password";
import * as qs from "query-string";
import { useHistory } from "react-router-dom";

const Login = (props) => {
  const { handleLoader, handleSignIn } = props;
  const initialState = {
    email: "",
    password: "",
    emailHelperText: "",
    passwordHelperText: "",
    otpHelperText: "Otp Required",
    invalidEmail: true,
    invalidPassword: true,
    otp: "",
    action: "Login",
    resetpasswordtoken: "",
    resetpassworduidb: "",

    
  };
  const [state, setState] = useState(initialState);
  const {
    email,
    password,
    emailHelperText,
    passwordHelperText,
    otpHelperText,
    invalidEmail,
    invalidPassword,
    otp,
    action,
    resetpasswordtoken,
    resetpassworduidb,
  } = state;
  const user = customLocalStorage.decrypt("iwmUser");
  const login = !user;
  const verifyOtp = !login && !user?.otpverified;
  const history = useHistory();

  const [uniqueStatusMsg,setUniqueStatusMsg] = useState("");
  const [uniqueStatusCode,setUniqueStatusCode] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  const Login = async (event) => {
    event.preventDefault();
    const params = {
      url: `${process.env.REACT_APP_API_URL}/auth/login`,
      data: {
        email: email,
        password: password,
        whattodo: `login`,
      },
      callBack: handleSignIn,
      method: `post`,
    };
    if (verifyOtp) {
      const sentOtp = user?.otp
      params.url = `${process.env.REACT_APP_API_URL}/auth/verify/otp/${otp}`;
      params.method = "get";
    }
    handleLoader(true);
    await apiRequest(params);
    handleLoader(false);
  };

  const handleInput = (event) => {
    const inputName = event.target.name;
    const inputValue = event.target.value;
    let {
      emailHelperText,
      passwordHelperText,
      otpHelperText,
      invalidEmail,
      invalidPassword,
    } = state;

    // Validate Email
    if (inputName === "email") {
      invalidEmail = true;
      emailHelperText = "Invalid email";
      if (Email.validate(inputValue)) {
        invalidEmail = false;
        emailHelperText = "";
      }
    }

    // Validate Password
    if (inputName === "password") {
      invalidPassword = true;
      passwordHelperText = "Invalid password";
      if (inputValue.length > 0) {
        invalidPassword = false;
        passwordHelperText = "";
      }
    }

    // Validate Otp
    if (inputName === "otp") {
      otpHelperText = "Invalid OTP";
      if (inputValue.length == process.env.REACT_APP_OTP_MIN_CHARACTERS) {
        otpHelperText = "";
      }
    }

    setState((prevState) => ({
      ...prevState,
      [inputName]: inputValue,
      invalidEmail,
      emailHelperText,
      invalidPassword,
      passwordHelperText,
      otpHelperText,
    }));
  };

  const handleBackToLogin = () => {
    setState((prevState) => ({
      ...prevState,
      action: "Login",
    }));
  };



  


  useEffect(() => {
    const urlParams = qs.parse(window.location.search);
    const { resetpasswordtoken, resetpassworduidb } = urlParams ?? {};

    if (resetpasswordtoken && resetpassworduidb) {
      setState((prevState) => ({
        ...prevState,
        resetpasswordtoken,
        resetpassworduidb,
        action: "Key in new password",
      }));
    }

    // Change 2000 to the desired timeout in milliseconds

  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        {(login || verifyOtp) && (
          <Avatar>
            <LockOutlinedIcon />
          </Avatar>
        )}
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      ></Box>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <form noValidate onSubmit={Login}>
          {login && (
            <>
              <TextField
                value={email}
                onChange={handleInput}
                error={invalidEmail}
                helperText={emailHelperText}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                // onChange={handleUserInput}
              />
              <TextField
                value={password}
                onChange={handleInput}
                error={invalidPassword}
                helperText={passwordHelperText}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
            </>
          )}
          {verifyOtp && (
            
            <TextField
              value={otp}
              onChange={handleInput}
              error={!!otpHelperText}
              helperText={otpHelperText}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="otp"
              label="OTP"
              type="number"
              id="otp"
            />
          )}
          {(login || verifyOtp) && (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={
                verifyOtp
                  ? !!otpHelperText
                  : login
                  ? invalidEmail || invalidPassword
                  : false
              }
            >
              {verifyOtp ? "Verify OTP" : "Sign In"}
            </Button>
          )}
          {verifyOtp && (
            <Grid
              container
              onClick={() => {
                localStorage.clear();
                setState((prevState) => ({
                  ...prevState,
                  otpHelperText: "",
                }));
              }}
            >
              <Grid item xs>
                <Link
                  href="#"
                  variant="body2"
                  onClick={() => {
                    localStorage.clear();
                    setState((prevState) => ({
                      ...prevState,
                      otp: "",
                    }));
                  }}
                >
                  Back to Login
                </Link>
              </Grid>
            </Grid>
          )}
          {login && (
            <>
              <Grid container>
                <Grid item xs>
                  <Link
                    href="#"
                    variant="body2"
                    onClick={() => {
                      setState((prevState) => ({
                        ...prevState,
                        action: "Reset password",
                      }));
                    }}
                  >
                    Forgot password?
                  </Link>
                </Grid>
              </Grid>
              {/* <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                    Sign Up
                  </Link>
                </Grid>
              </Grid> */}
            </>
          )}
        </form>

      </Box>{" "}

      <ResetPassword
        action={action}
        resetpasswordtoken={resetpasswordtoken}
        resetpassworduidb={resetpassworduidb}
        handleBackToLogin={handleBackToLogin}
      />

    </div>
  );
};
export default Login;
